import { TenantEntity } from '../TenantEntity'

export class FbaSetupSetting extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'FbaSetupSetting'
  }
  get minWeight() {
    return this._data.minWeight
  }
  set minWeight(minWeight) {
    this._data.minWeight = minWeight || 0
  }
  get maxWeight() {
    return this._data.maxWeight
  }
  set maxWeight(maxWeight) {
    this._data.maxWeight = maxWeight || 0
  }
  get calcMethod() {
    return this._data.calcMethod
  }
  set calcMethod(calcMethod) {
    this._data.calcMethod = calcMethod || 0
  }
  get calcAccuracy() {
    return this._data.calcAccuracy
  }
  set calcAccuracy(calcAccuracy) {
    this._data.calcAccuracy = calcAccuracy || 0.0
  }
  get quotationUuid() {
    return this._data.quotationUuid
  }
  set quotationUuid(quotationUuid) {
    this._data.quotationUuid = quotationUuid
  }
  get amount() {
    return this._data.amount
  }
  set amount(amount) {
    this._data.amount = amount || 0.0
  }
  get customerPriceSetupSettingUuid() {
    return this._data.customerPriceSetupSettingUuid
  }
  set customerPriceSetupSettingUuid(customerPriceSetupSettingUuid) {
    this._data.customerPriceSetupSettingUuid = customerPriceSetupSettingUuid
  }
}
